import axios from 'axios';
import { ENDPOINT } from '../ENDPOINT';

const CheckInService = {
  // Fetch latest check-in status and logs for a user
  getCheckInStatus: async (uid) => {
    try {
      const response = await axios.get(`${ENDPOINT.checkin}/${uid}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching check-in status:", error);
      throw error;
    }
  },

  // Create a new check-in
  createCheckIn: async (payload) => {
    try {
      const response = await axios.post(`${ENDPOINT.checkin}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating check-in:", error);
      throw error;
    }
  },

  // Update a user's latest check-in (e.g., check-out)
  updateCheckIn: async (uid, payload) => {
    try {
      const response = await axios.put(`${ENDPOINT.checkin}/${uid}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating check-in:", error);
      throw error;
    }
  },

  // Add break/activity log to a check-in
  addCheckInLog: async (payload) => {
    try {
      const response = await axios.post(`${ENDPOINT.checkin}/log`, payload);
      return response.data;
    } catch (error) {
      console.error("Error adding check-in log:", error);
      throw error;
    }
  },



  getCheckInHistory: async (uid) => {
  try {
    const response = await axios.get(`${ENDPOINT.checkin}/history/${uid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching check-in history:", error);
    throw error;
  }
},

getCheckInHistoryByDate: async (uid, date) => {
  try {
    const response = await axios.get(
      `${ENDPOINT.checkin}/history/search/${uid}`,
      { params: { date: date } } // <-- explicitly use "date" as query param key
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching history by date/month/year:", error);
    throw error;
  }
},


getCheckInHistoryWithLogs: async (uid) => {
  try {
    const response = await axios.get(`${ENDPOINT.checkin}/history/logs/${uid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching check-in history with logs:", error);
    throw error;
  }
},


// Month-wise attendance
getCheckInHistoryByMonth: async (uid, month) => {
  try {
    const response = await axios.get(`${ENDPOINT.checkin}/history/month/${uid}`, {
      params: { month } // format: "YYYY-MM"
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching month attendance:", error);
    throw error;
  }
},

// Year-wise attendance
getCheckInHistoryByYear: async (uid, year) => {
  try {
    const response = await axios.get(`${ENDPOINT.checkin}/history/year/${uid}`, {
      params: { year } // format: "YYYY"
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching year attendance:", error);
    throw error;
  }
},

//salary approved

  approveSalary: async (payload) => {
    try {
      const response = await axios.post(`${ENDPOINT.employeesalaryissued}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error approving salary:", error);
      throw error;
    }
  },

  // Get salary by employee ID and month
  getSalaryByEmpMonth: async (empId, month) => {
    try {
      const response = await axios.get(`${ENDPOINT.employeesalaryissued}/${empId}/${month}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching salary by emp and month:", error);
      throw error;
    }
  },

  // Get all salaries
  getAllSalaries: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.employeesalaryissued}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching all salaries:", error);
      throw error;
    }
  },





};

export default CheckInService;
